<script setup>
  import SecondaryButton from '@/Components/SecondaryButton.vue';
</script>

<template>
  <div class="relative">
    <div
      class="z-50 flex flex-col w-10/12 p-4 mx-auto text-white h-96 rounded-2xl bg-primary"
    >
      <div
        class="w-full mx-auto mt-12 text-2xl text-center font-title md:text-4xl"
      >
        <p class="font-semibold">Start Your Creative Journey Today</p>
        <p class="font-bold">Create, Connect, &amp; Succeed</p>
      </div>
      <p class="w-2/3 mx-auto mt-6 text-sm text-center">
        Spicy Collab makes it easy for creators to connect and manage their jobs.
        Sign up now and unlock all the tools you need to take your creative
        career to the next level.
      </p>
      <a href="/register" class="mx-auto mt-4">
        <SecondaryButton class="mx-auto mt-4 hover:border-white" :class="['text-black', 'bg-white']">
          <div :class="['text-black']">Get Started Now</div>
        </SecondaryButton>
      </a>
    </div>
  </div>
</template>

<style scoped></style>
